import { render, staticRenderFns } from "./TableListOrder.vue?vue&type=template&id=afd12120&lang=pug"
import script from "./TableListOrder.vue?vue&type=script&lang=js"
export * from "./TableListOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports